module.exports = __webpack_public_path__ + "static/media/error.201e41e9.svg";